var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2751 17.7831C9.36674 17.7831 8.45841 17.4415 7.76674 16.7498C6.38341 15.3665 6.38341 13.1248 7.76674 11.7415L9.83341 9.68314C10.0751 9.44147 10.4751 9.44147 10.7167 9.68314C10.9584 9.9248 10.9584 10.3248 10.7167 10.5665L8.65007 12.6248C7.75841 13.5165 7.75841 14.9748 8.65007 15.8665C9.54174 16.7581 11.0001 16.7581 11.8917 15.8665L15.1334 12.6248C16.1167 11.6415 16.6584 10.3331 16.6584 8.94147C16.6584 7.5498 16.1167 6.24147 15.1334 5.25814C13.1001 3.2248 9.80007 3.2248 7.76674 5.25814L4.23341 8.79147C3.40841 9.61647 2.95007 10.7165 2.95007 11.8831C2.95007 13.0498 3.40841 14.1498 4.23341 14.9748C4.47507 15.2165 4.47507 15.6165 4.23341 15.8581C3.99174 16.0998 3.59174 16.0998 3.35007 15.8581C2.29174 14.7915 1.70007 13.3831 1.70007 11.8831C1.70007 10.3831 2.28341 8.96647 3.35007 7.90814L6.88341 4.3748C9.40007 1.85814 13.5001 1.85814 16.0167 4.3748C17.2334 5.59147 17.9084 7.21647 17.9084 8.94147C17.9084 10.6665 17.2334 12.2915 16.0167 13.5081L12.7751 16.7498C12.0834 17.4415 11.1834 17.7831 10.2751 17.7831Z",
    fill: "#60656C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.acfeb72d5acf0d6c774f7275e949d4f8.svg";
export { ForwardRef as ReactComponent };